// Формирует ключи frontend-флагов бокового меню. Утилита фиксирует общий
// контракт имён с backend и не определяет, для каких пунктов включена плашка.

// Возвращает Flipper-ключ временной плашки new для пункта меню.
export function sidebarNewBadgeFeatureKey(itemKey) {
  return `sidebar_new_badge_${itemKey}`;
}
